/**
 * Обмен refresh-токена aseller.io на платформенный access (CU-869e4mvzp).
 *
 * В Hub-embed своего логина нет: Hub присылает в INIT refresh-токен пользователя
 * (asellerToken), фронт меняет его на access через прокси бэкенда
 * (POST /api/platform/token, без auth-гарда — обмен и есть начало авторизации) и
 * шлёт access как Authorization: Bearer.
 *
 * Запрос идёт «голым» axios, а не apiClient: интерсептор apiClient сам вызывает
 * обмен на 401 — рекурсия недопустима.
 *
 * NO FALLBACK: невалидный refresh (401 refresh_token_invalid от платформы) и
 * недоступная платформа (502) пробрасываются наверх — их видит вызывающий код.
 */

import axios from 'axios';
import { API_URL } from './apiUrl';

interface PlatformTokenResponse {
  accessToken: string;
}

export async function exchangePlatformToken(refreshToken: string): Promise<string> {
  const { data } = await axios.post<PlatformTokenResponse>(
    `${API_URL}/api/platform/token`,
    { refreshToken },
  );
  if (!data?.accessToken) {
    throw new Error('platform token exchange: пустой accessToken в ответе');
  }
  return data.accessToken;
}
